// src/pages/ShopNow.jsx
import React from "react";

export default function ShopNow() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 p-6">
      {/* Main Card */}
      <div className="bg-white rounded-3xl shadow-2xl p-10 max-w-lg text-center">
        <h1 className="text-4xl font-extrabold text-gray-800 mb-4">
          Welcome to Our Shop
        </h1>
        <p className="text-gray-600 mb-8">
          Explore our exclusive collection of products. Click below to start shopping and enjoy amazing deals!
        </p>

        {/* Shop Now Button */}
        <a
          href="https://meruram.com/shopping/index.php"
          className="inline-block bg-blue-600 text-white text-lg font-semibold px-8 py-4 rounded-full shadow-lg transform transition duration-300 hover:scale-105 hover:bg-blue-700"
        >
          🛒 Shop Now
        </a>
      </div>

      {/* Footer Note */}
      <p className="mt-8 text-white text-sm">
        Secure checkout and fast delivery guaranteed.
      </p>
    </div>
  );
}
